import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["panel", "tab"];

  connect() {
    console.log("Tabs Controller Connected");
  }

  change(event) {
    this.tabTargets.forEach(this.deactivate);

    this.activate(event.currentTarget);
    this.changeTab(event.params.id);
  }

  activate(tab) {
    tab.classList.add(
      "bg-white",
      "lg:bg-white/10",
      "lg:ring-1",
      "lg:ring-inset",
      "lg:ring-white/10"
    );

    tab.classList.remove("hover:bg-white/10", "lg:hover:bg-white/5");

    const button = tab.querySelector("button");
    button.classList.add("text-teal-600", "lg:text-white");
    button.classList.remove("text-teal-100", "hover:text-white");

    this.panelTarget.querySelector("p").innerHTML =
      tab.querySelector("p").innerHTML;
  }

  deactivate(tab) {
    tab.classList.remove(
      "bg-white",
      "lg:bg-white/10",
      "lg:ring-1",
      "lg:ring-inset",
      "lg:ring-white/10"
    );

    tab.classList.add("hover:bg-white/10", "lg:hover:bg-white/5");

    const button = tab.querySelector("button");

    button.classList.remove("text-teal-600", "lg:text-white");
    button.classList.add("text-teal-100", "hover:text-white", "lg:text-white");
  }

  changeTab(id) {
    const tabToActivate = document.querySelector("#" + id);
    this.panelTargets.forEach((panel) => panel.classList.add("hidden"));
    tabToActivate.classList.remove("hidden");
  }
}
